export default __webpack_public_path__ + "static/media/Test portal new-01.8244ccd8.svg";